module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_vestfold_telemark_pos.caf306ff.png";